import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminWorks(filters, cursor) {
    return useQuery({
        queryKey: adminKeys.worksList(filters, cursor),
        queryFn: () => adminApi.browseWorks(filters, cursor),
    });
}
